// Primero: fija el modo de color de three antes de que cualquier módulo cree colores.
import './util/threeLegacy';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import {BrowserRouter} from "react-router";
import App from './App';
import {initDatadog} from './util/datadog';

initDatadog();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </React.StrictMode>
);
